// Phần trăm convert của từng giai đoạn convert
export default {
    SendData: 30,
    ConvertData: 30,
    PostBatch: 40,
  };
  